<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Vendedores</h1>
    <button class="btn btn-primary" (click)="novoVendedor()">Incluir Novo Vendedor</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por nome..." [(ngModel)]="searchTerm" (input)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Funcionário</th>
          <th scope="col" class="text-center">Status</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let vendedor of paginatedVendedores">
          <th scope="row">{{ vendedor.id }}</th>
          <td>{{ vendedor.nomeFuncionario }} {{ vendedor.sobrenomeFuncionario }}</td>
          <td class="text-center">
            <span class="badge" [class.bg-success]="vendedor.ativo" [class.bg-secondary]="!vendedor.ativo">
              {{ vendedor.ativo ? 'ATIVO' : 'INATIVO' }}
            </span>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm me-2" (click)="editarVendedor(vendedor.id)">Editar</button>
            <button type="button" class="btn btn-danger btn-sm" (click)="deleteVendedor(vendedor.id)">Excluir</button>
          </td>
        </tr>
        <tr *ngIf="paginatedVendedores.length === 0">
          <td colspan="4" class="text-center text-muted py-4">Nenhum vendedor encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(1)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages)">Última</a>
      </li>
    </ul>
  </nav>
</div>
